import { Planzone, Identifiable, PlanzoneContacts } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function updatePlanzoneContacts(httpClient: HttpClient) {
  return (planzone: Identifiable<Planzone>, contacts: PlanzoneContacts) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/planzones/${planzone.uuid}`,
      method: HttpMethods.PATCH,
      data: {
        contacts: contacts.billingContacts.reduce(
          (nextContacts, billingContact, index) => ({
            ...nextContacts,
            [`billing.contacts[${index}].uuid`]: billingContact.uuid,
          }),
          {
            "decisionMaker.contacts[0].uuid":
              contacts.decisionMakerContact.uuid,
            "technicalManager.contacts[0].uuid":
              contacts.technicalManagerContact.uuid,
            "onboarding.contacts[0].uuid": contacts.onboardingContact.uuid,
          },
        ),
      },
    });
}
export { updatePlanzoneContacts };
